import { compose as t } from "../../tailwind-buddy-interface.js";
import { labelStyles as e } from "../../mixins/typography.js";
const o = {
  foundation: {
    root: `
      inline-flex
      max-w-full
      items-center
      gap-x-025
      rounded-pill
      backdrop-blur-md
    `,
    label: "font-weight-bold text-center",
    icon: "shrink-0"
  },
  sizeSm: {
    root: `
      ps-150
      pe-150
      py-100
    `,
    label: `
      ps-050
      pe-050
      ${e.md}
    `
  },
  sizeMd: {
    root: `
      ps-150
      pe-150
      py-075
    `,
    label: `
      p-050
      ${e.lg}
    `
  },
  sizeLg: {
    root: `
      ps-200
      pe-200
      py-150
    `,
    label: `
      ps-100
      pe-100
      py-025
      ${e.xl}
    `
  },
  variantSolid: {
    root: "",
    label: "text-color-primary-inverse",
    icon: "text-icon-color-primary-inverse"
  },
  variantSubtle: {},
  variantOutlined: {
    /** TODO: use `-outline-offset-sm` once outline offset tokens are available */
    root: `
      outline
      outline-width-sm
      -outline-offset-1
    `
  }
}, n = t({
  slots: o.foundation,
  variants: {
    /** Sets the chip color. */
    colorScheme: {
      primary: {},
      neutral: {},
      informative: {},
      positive: {},
      negative: {},
      notice: {},
      special: {}
    },
    /** Sets the chip size. */
    size: {
      sm: o.sizeSm,
      md: o.sizeMd,
      lg: o.sizeLg
    },
    /** Sets the chip variant. */
    variant: {
      solid: o.variantSolid,
      subtle: o.variantSubtle,
      outlined: o.variantOutlined
    }
  },
  compoundVariants: [
    /*=============================================
      =            variant="solid"                  =
      =============================================*/
    // variant="solid" / colorScheme="primary"
    {
      conditions: {
        colorScheme: "primary",
        variant: "solid"
      },
      class: {
        root: "bg-color-scheme-brand-primary-500"
      }
    },
    // variant="solid" / colorScheme="neutral"
    {
      conditions: {
        colorScheme: "neutral",
        variant: "solid"
      },
      class: {
        root: "bg-color-scheme-neutral-500"
      }
    },
    // variant="solid" / colorScheme="informative"
    {
      conditions: {
        colorScheme: "informative",
        variant: "solid"
      },
      class: {
        root: "bg-color-scheme-functional-informative-500"
      }
    },
    // variant="solid" / colorScheme="positive"
    {
      conditions: {
        colorScheme: "positive",
        variant: "solid"
      },
      class: {
        root: "bg-color-scheme-functional-positive-500"
      }
    },
    // variant="solid" / colorScheme="negative"
    {
      conditions: {
        colorScheme: "negative",
        variant: "solid"
      },
      class: {
        root: "bg-color-scheme-functional-negative-500"
      }
    },
    // variant="solid" / colorScheme="notice"
    {
      conditions: {
        colorScheme: "notice",
        variant: "solid"
      },
      class: {
        root: "bg-color-scheme-functional-notice-500"
      }
    },
    // variant="solid" / colorScheme="special"
    {
      conditions: {
        colorScheme: "special",
        variant: "solid"
      },
      class: {
        root: "bg-color-scheme-functional-special-500"
      }
    },
    /*=============================================
      =            variant="subtle"                 =
      =============================================*/
    // variant="subtle" / colorScheme="primary"
    {
      conditions: {
        colorScheme: "primary",
        variant: "subtle"
      },
      class: {
        root: "bg-color-scheme-brand-primary-100",
        label: "text-color-scheme-brand-primary-800",
        icon: "text-color-scheme-brand-primary-500"
      }
    },
    // variant="subtle" / colorScheme="neutral"
    {
      conditions: {
        colorScheme: "neutral",
        variant: "subtle"
      },
      class: {
        root: "bg-color-scheme-neutral-100",
        label: "text-color-scheme-neutral-800",
        icon: "text-color-scheme-neutral-500"
      }
    },
    // variant="subtle" / colorScheme="informative"
    {
      conditions: {
        colorScheme: "informative",
        variant: "subtle"
      },
      class: {
        root: "bg-color-scheme-functional-informative-100",
        label: "text-color-scheme-functional-informative-800",
        icon: "text-color-scheme-functional-informative-500"
      }
    },
    // variant="subtle" / colorScheme="positive"
    {
      conditions: {
        colorScheme: "positive",
        variant: "subtle"
      },
      class: {
        root: "bg-color-scheme-functional-positive-100",
        label: "text-color-scheme-functional-positive-800",
        icon: "text-color-scheme-functional-positive-500"
      }
    },
    // variant="subtle" / colorScheme="negative"
    {
      conditions: {
        colorScheme: "negative",
        variant: "subtle"
      },
      class: {
        root: "bg-color-scheme-functional-negative-100",
        label: "text-color-scheme-functional-negative-800",
        icon: "text-color-scheme-functional-negative-500"
      }
    },
    // variant="subtle" / colorScheme="notice"
    {
      conditions: {
        colorScheme: "notice",
        variant: "subtle"
      },
      class: {
        root: "bg-color-scheme-functional-notice-100",
        label: "text-color-scheme-functional-notice-800",
        icon: "text-color-scheme-functional-notice-500"
      }
    },
    // variant="subtle" / colorScheme="special"
    {
      conditions: {
        colorScheme: "special",
        variant: "subtle"
      },
      class: {
        root: "bg-color-scheme-functional-special-100",
        label: "text-color-scheme-functional-special-800",
        icon: "text-color-scheme-functional-special-500"
      }
    },
    /*=============================================
      =            variant="outlined"               =
      =============================================*/
    // variant="outlined" / colorScheme="primary"
    {
      conditions: {
        colorScheme: "primary",
        variant: "outlined"
      },
      class: {
        root: "outline-color-scheme-brand-primary-400",
        label: "text-color-scheme-brand-primary-800",
        icon: "text-color-scheme-brand-primary-400"
      }
    },
    // variant="outlined" / colorScheme="neutral"
    {
      conditions: {
        colorScheme: "neutral",
        variant: "outlined"
      },
      class: {
        root: "outline-color-scheme-neutral-400",
        label: "text-color-scheme-neutral-800",
        icon: "text-color-scheme-neutral-400"
      }
    },
    // variant="outlined" / colorScheme="informative"
    {
      conditions: {
        colorScheme: "informative",
        variant: "outlined"
      },
      class: {
        root: "outline-color-scheme-functional-informative-400",
        label: "text-color-scheme-functional-informative-800",
        icon: "text-color-scheme-functional-informative-400"
      }
    },
    // variant="outlined" / colorScheme="positive"
    {
      conditions: {
        colorScheme: "positive",
        variant: "outlined"
      },
      class: {
        root: "outline-color-scheme-functional-positive-400",
        label: "text-color-scheme-functional-positive-800",
        icon: "text-color-scheme-functional-positive-400"
      }
    },
    // variant="outlined" / colorScheme="negative"
    {
      conditions: {
        colorScheme: "negative",
        variant: "outlined"
      },
      class: {
        root: "outline-color-scheme-functional-negative-400",
        label: "text-color-scheme-functional-negative-800",
        icon: "text-color-scheme-functional-negative-400"
      }
    },
    // variant="outlined" / colorScheme="notice"
    {
      conditions: {
        colorScheme: "notice",
        variant: "outlined"
      },
      class: {
        root: "outline-color-scheme-functional-notice-400",
        label: "text-color-scheme-functional-notice-800",
        icon: "text-color-scheme-functional-notice-400"
      }
    },
    // variant="outlined" / colorScheme="special"
    {
      conditions: {
        colorScheme: "special",
        variant: "outlined"
      },
      class: {
        root: "outline-color-scheme-functional-special-400",
        label: "text-color-scheme-functional-special-800",
        icon: "text-color-scheme-functional-special-400"
      }
    }
  ],
  defaultVariants: {
    colorScheme: "primary",
    size: "md",
    variant: "solid"
  },
  responsiveVariants: ["size"]
})();
export {
  o as chipCommonStyles,
  n as chipVariants
};
